import React from "react";
import { useAppContext } from "../context/AppContext";

const MainLayout = ({ children }) => {
  const { direction, language, locale } = useAppContext();
  return (
    <main
      className="w-full font-sans h-screen bg-background relative flex flex-col overflow-hidden"
      dir={direction}
      lang={language}
      data-locale={locale}
    >
      {children}
    </main>
  );
};

export default MainLayout;
